import PropTypes from "prop-types";
import React from "react";
import { format } from "date-fns";
import { Dialog, DialogContent, Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import oneCoin from "../../../assets/ic_one_coin.png";
import { useProductCatalog } from "../../../Providers/Data/ProductCatalogProvider.jsx";

const useStyles = makeStyles((theme) => ({
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#1B1C1C",
  },
  dateTitle: {
    color: "#3D4853",
    fontSize: 16,
    marginRight: "auto",
    marginBottom: theme.spacing(1),
  },
  cardBox: {
    position: "relative",
    backgroundColor: "#FAFBFB",
    border: "2px solid rgba(0, 0, 0, .08)",
    borderRadius: theme.spacing(2),
    padding: "2px 20px",
    cursor: "pointer",
    marginBottom: theme.spacing(2),
    width: "100%",
  },
  oneTransaction: {
    borderBottom: "2px solid rgba(0, 0, 0, .08)",
    padding: "12px 0",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  titleBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  titleCard: {
    fontSize: 18,
    lineHeight: 1.4,
    fontWeight: 500,
    width: 400,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  oneCoinImg: {
    width: 24,
    height: 24,
  },
  coinPrice: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.secondary.yellow,
    marginRight: theme.spacing(0.5),
  },
  coinRedPrice: {
    color: "#BA1A1A",
  },
  descriptionBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "#54606B",
    fontSize: 14,
    marginTop: theme.spacing(0.5),
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
  },
}));

/** */
const TransactionsListDialog = ({ dialogOpen, setDialogOpen }) => {
  const classes = useStyles();
  const { transactions } = useProductCatalog();

  /** */
  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog maxWidth="sm" open={dialogOpen} onClose={handleClose}>
      <DialogContent className={classes.content}>
        {transactions.length > 0 &&
          transactions.map((oneDay) => (
            <>
              <Typography className={classes.dateTitle}>{oneDay.date}</Typography>
              <Box key={oneDay.date} className={classes.cardBox}>
                {oneDay.items.map((transaction) => (
                  <Box key={transaction.id} className={classes.oneTransaction}>
                    <Box className={classes.titleBox}>
                      <Typography className={classes.titleCard}>{transaction.titleText}</Typography>
                      <Box className={classes.titleBox}>
                        <div className={`${classes.coinPrice} ${transaction.amount < 0 ? classes.coinRedPrice : ""}`}>
                          {/* Суммы транзакций могут быть дробными, отображаем округлённо до целого */}
                          {Math.round(transaction.amount)}
                        </div>
                        <img className={classes.oneCoinImg} src={oneCoin} alt="oneCoin" />
                      </Box>
                    </Box>

                    <Box className={classes.descriptionBox}>
                      <Typography className={classes.descriptionCard}>{transaction.description}</Typography>
                      <Typography className={classes.descriptionCard}>
                        {format(transaction.createdAt, "HH:mm")}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            </>
          ))}
      </DialogContent>

      <IconButton aria-label="close" className={classes.closeButton} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

TransactionsListDialog.propTypes = {
  dialogOpen: PropTypes.bool.isRequired,
  setDialogOpen: PropTypes.func.isRequired,
};

export default TransactionsListDialog;
